module.exports = __webpack_public_path__ + "img/gdp-logo-white.b8762f94.svg";